import { useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import routerUtil from "@/utils/routerUtil";
import { STORAGE } from "project-config/constants";

export function useSwitchSidebar() {
  const location = useLocation();
  const [pathname, setPathname] = useState<string>();

  useEffect(() => {
    setPathname(location.pathname);
  }, [location.pathname]);

  const switchSidebar = (path?: string) => {
    if (!path) return;
    routerUtil.navigate?.(path);
    setPathname(path);
    if (sessionStorage.getItem(STORAGE.NETWORK_ERROR)) {
      sessionStorage.setItem(STORAGE.NETWORK_ERROR, "");
      window.location.reload();
    }
  };

  return { pathname, setPathname, switchSidebar };
}
